module.exports = __webpack_public_path__ + "img/hy.fcfdc594.png";